<!-- daisyUI Drawer 기반 반응형 레이아웃 -->
<div class="drawer relative w-screen" [class.lg:drawer-open]="isSidebarOpen()">
  <!-- 드로어 토글 체크박스 -->
  <input id="main-drawer" type="checkbox" class="drawer-toggle" [checked]="isSidebarOpen()" />

  <!-- 메인 콘텐츠 영역 -->
  <div class="drawer-content flex flex-col h-screen overflow-y-auto" #contentArea>
    <!-- 모바일 전용 토글 버튼 -->
    <label
      for="main-drawer"
      aria-label="메뉴 열기"
      class="btn btn-ghost size-10 min-h-10 min-w-10 p-0 fixed z-50 bg-white shadow-md border border-zinc-200 rounded-full hover:bg-zinc-50 items-center justify-center right-4 top-8"
      [class.flex]="!isSidebarOpen()"
      [class.hidden]="isSidebarOpen()"
      [class.lg:hidden]="true"
      (click)="toggleSidebar()">
      <lepi-icon name="mdi:menu" class="text-zinc-500" />
    </label>

    <!-- 메인 콘텐츠 -->
    <main
      class="flex-1 px-4 sm:px-8 md:px-16 lg:px-36 py-16 md:py-25 bg-linear-to-b from-[#EAF4FB] via-[#F4F7FB] to-[#FAFAFC]">
      <router-outlet />
    </main>
    <app-footer />
  </div>

  <!-- 사이드바 영역 -->
  <div class="drawer-side drawer-end lg:drawer-start z-40">
    <label for="main-drawer" aria-label="close sidebar" class="drawer-overlay"></label>
    <div class="h-full bg-base-100 border-l lg:border-l-0 lg:border-r border-zinc-100">
      <app-sidebar (closeSidebar)="toggleSidebar()" />
    </div>
  </div>
</div>
